import { AxiosGlobalFilters } from '../config';
import { CreateUsuarioCommand, SavePermissoesUsuarioCommand } from './UsuariosService.types';

/** Query do GET /v2/usuarios: escalares e listas (repetidas na URL). */
export type ParamsListagemUsuarios = Record<string, string | number | boolean | number[]>;

export * from './UsuariosService.types';

// API Lighthouse de usuários (branch API-de-Usuarios).
// EmpresaId/UnidadeId sempre em HEADER — nunca no body ([JsonIgnore] no back).
export const UsuariosService = {
  createUsuario: ({
    data,
    EmpresaId,
    UnidadeId,
  }: {
    data: CreateUsuarioCommand;
    EmpresaId: number;
    UnidadeId?: number;
  }) => {
    const headers: Record<string, string | number> = { 'content-type': 'application/json', EmpresaId };
    // UnidadeId opcional: quando enviado, o POST já cria a linha de permissão daquela unidade (tipo 3/4).
    if (UnidadeId !== undefined) headers.UnidadeId = UnidadeId;
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/usuarios',
      data,
      headers,
    });
  },
  savePermissoesUsuario: ({ data, EmpresaId }: { data: SavePermissoesUsuarioCommand; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: '/v1/usuarios/permissoes',
      data,
      headers: { 'content-type': 'application/json', EmpresaId },
    });
  },
  getPermissoesCatalogo: ({ tipoUsuarioAlvo, EmpresaId }: { tipoUsuarioAlvo?: number; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/permissoes',
      params: { tipoUsuarioAlvo },
      headers: { EmpresaId },
    });
  },
  // NOVO-38: catálogo de cargos da empresa (inclui os de unidade — `siteId` nulo = escopo empresa).
  getCargos: ({ EmpresaId }: { EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/cargos',
      headers: { EmpresaId },
    });
  },
  // NOVO-38 F2: listagem paginada. Listas vão REPETIDAS (`UnidadeId=1&UnidadeId=2`), o formato que
  // o ASP.NET binda: o default do axios (`UnidadeId[]=1`) seria ignorado em silêncio pela API.
  getUsuariosV2: ({ params, EmpresaId }: { params: ParamsListagemUsuarios; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v2/usuarios',
      params,
      paramsSerializer: { indexes: null },
      headers: { EmpresaId },
    });
  },
  // NOVO-38 F2 (L4): soft delete e o inverso. `inativar` existe em Dev; `ativar` é espelho exato
  // dele (openspec) e hoje só existe no mock — depende da B3. Não existe exclusão de usuário.
  inativarUsuario: ({ usuario, EmpresaId }: { usuario: number; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: `/v1/usuarios/inativar/${usuario}`,
      headers: { EmpresaId },
    });
  },
  ativarUsuario: ({ usuario, EmpresaId }: { usuario: number; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: `/v1/usuarios/ativar/${usuario}`,
      headers: { EmpresaId },
    });
  },
  getPermissoesUsuario: ({ usuario, EmpresaId }: { usuario: number; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/usuarios/${usuario}/permissoes`,
      headers: { EmpresaId },
    });
  },
  getUnidadesAtivas: ({ EmpresaId }: { EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v2/unidades/ativas',
      headers: { EmpresaId },
    });
  },
};
